import type * as Schema from 'src/types/graphql';

import type { DisplayedRightToWork } from './types';

export const mapRightsToWorkIntoInputs = (
  rightsToWork: DisplayedRightToWork[],
): Schema.UpdateRightToWorkInput[] =>
  rightsToWork.map(({ id, country: { countryCode }, type2 }) => ({
    id,
    countryCode,
    type2: type2?.id
      ? {
          id: type2?.id,
        }
      : null,
  }));

export const removeDisplayedRightToWork = ({
  countryCode,
  rightToWorkList,
}: {
  countryCode: string;
  rightToWorkList: DisplayedRightToWork[];
}) =>
  rightToWorkList.filter(
    (rightToWork) => rightToWork.country.countryCode !== countryCode,
  );

export const updateDisplayedRightToWork = (
  currentRightsToWork: DisplayedRightToWork[],
  rightToWorkInput: DisplayedRightToWork,
): DisplayedRightToWork[] => {
  const isExistingInputUpdate = currentRightsToWork.some(
    (right) =>
      right.country.countryCode === rightToWorkInput.country.countryCode,
  );

  return isExistingInputUpdate
    ? currentRightsToWork.map((right) =>
        rightToWorkInput.country.countryCode === right.country.countryCode
          ? {
              ...right,
              type2: rightToWorkInput.type2, // Only update type2 since other fields are not editable
            }
          : right,
      )
    : [...currentRightsToWork, rightToWorkInput];
};
